module.exports = __webpack_public_path__ + "img/share2.jpg";